import { Button, Skeleton, Typography } from "@mui/material"
import CarType from "../../interfaces/car"
import { useTranslation } from "react-i18next"
import dayjs from "dayjs";
import { useState } from "react";
import ReportDialog from "../report/ReportDialog";

type PropsType = {
    car?: CarType
}
export default function CardSearchItem({ car }: PropsType) {
    const [openReport, setOpenReport] = useState(false);
    const { t } = useTranslation();

    const handleCloseReport = () => {
        setOpenReport(false);
    }

    const handleOpenReport = () => {
        setOpenReport(true);
    }
    return (
        <div className="rounded-lg bg-primary-hover flex flex-row overflow-hidden">
            <div className="relative">
                <img src={'/car_sample.jpeg'} className="h-44 w-36 object-cover" />
                <div className="absolute left-0 right-0 top-0 bottom-0 bg-primary-outborder text-primary-contrastText">
                    <Typography className="center w-full text-center">{car ? dayjs.duration(dayjs(car.register_date).diff(dayjs())).locale('fa').humanize(true) : <Skeleton width={100} />}</Typography>
                </div>
            </div>
            <div className="flex flex-col p-4 w-full">
                <div className="flex flex-row justify-between border-b border-solid border-primary-outborder pb-2.5">
                    <Typography className="text-success-main font-medium text-sm">{car?.branch.name}</Typography>
                    <Typography className="text-primary-main font-normal text-base flex flex-row gap-2">{t('chassis_number')}: {car?.chassis ?? <Skeleton className="w-20" />}</Typography>
                </div>
                <div className="grow flex flex-row justify-between items-end">
                    <div className="flex flex-col gap-1.5">
                        <Typography className="text-xl text-text-primary">{car?.type ?? <Skeleton className="w-20" />}</Typography>
                        <Typography className="text-text-secondary">{car?.color ?? <Skeleton className="w-10" />}</Typography>
                        <Typography className="text-text-secondary">{car ? new Date(car.register_date).toLocaleString('fa-IR') : <Skeleton className="w-20" />}</Typography>
                    </div>
                    <div className="flex flex-col gap-3">
                        <Typography>{t('cost')}: {car?.price?.toLocaleString()}</Typography>
                        <Button onClick={handleOpenReport} variant="contained">{t('see_report')}</Button>
                    </div>
                </div>
            </div>
            <ReportDialog onClose={handleCloseReport} open={openReport} data={car} />
        </div>
    )
}
